/*@ngInject*/
const ClientIdRepository = function ($window, appTypeConfigurationModel, coreConstant) {
    this.getClientId = () => {
        return $window.sessionStorage.getItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.SESSION_STORAGE_CLIENT_ID_KEY));
    };

    this.setClientId = (clientId) => {
        $window.sessionStorage.setItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.SESSION_STORAGE_CLIENT_ID_KEY), clientId);
    };

    this.removeClientId = () => {
        return $window.sessionStorage.removeItem(appTypeConfigurationModel.appendConsoleType(coreConstant.authorization.SESSION_STORAGE_CLIENT_ID_KEY));
    };
};

angular.module('gw-um-auth')
    .service('clientIdRepository', ClientIdRepository);
